module.exports = ['$utils', '$q', 'User', '$ionicPopup', '$translate', 'mailFolderService', '$timeout',
  function ($utils, $q, User, $ionicPopup, $translate, mailFolderService, $timeout) {
    /**
     * user:triggerSecondAuth (触发二次验证)
     * @param tempSid     {string}  - 用于验证的临时 session id。如果传入此参数，临时 session 里必须有 vc_uid 属性。
                                        已登录用户调用时可不传递此参数，默认会创建一个新的临时 session
     * @param trans       {string}  - 需要二次验证的业务名称,如 login、change_password、update_second_auth等
     * @return  result     {object}
     * ResultCode:
       S_OK                         - 成功. 同时会发送短信验证码或推送 OTP 二次验证通知(前提是绑定短信/OTP验证)。
       FA_USER_NOT_FOUND            - 用户不存在，指通过 tempSid 传递过来的临时 session 里的 vc_uid 对应的用户不存在。
       FA_SECOND_AUTH_DISABLED      - 没有绑定二次验证
     */
    function triggerSecondAuth(user, options) {
      const deferred = $q.defer()
      const currentUser = user || User.getCurrentUser()
      currentUser.simpleCall({
        query: {
          func: 'user:triggerSecondAuth'
        },
        data: options
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data)
        } else {
          deferred.reject(code)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /**
     * user:updateSecondAuth (修改二次验证）
     * @param tempSid    {string}      - 用于修改二次验证的临时 session id. 如果之前未绑定二次验证，可以不传入
     * @param verifyCode {string}      - 修改为 SMS / DYNAMIC / OTP 时需要传入，验证新的二次验证方式
     * @param uid        {string}      - 绑定的用户
     * @param secret     {string}
     * @param deviceInfo {object}      - 手机绑定 OTP 验证方式时传入
     * @param bindIssuer {string}      - 绑定当前 uid otp 验证的用户所在应用名称
     * @param bindUid"   {string}      - 绑定当前 uid otp 验证的用户账号
     *  deviceInfo
     {
         "uuid"     : <string>     - 手机 UUID
          "model"    : <string>     - "iPhone 5,1" "Passion"
          "platform" : <string>     - "iOS", "Android"
          "version"  : <string>     - "8.2", "2.2"
      }

      * @return  result  {object}
      * ResultCode:
      S_OK                            - 成功
      FA_USER_NOT_FOUND               - 临时 session 里没有 vc_uid，或对应的用户不存在
      FA_FORBIDDEN                    - 不允许修改 (校验不通过等原因)
      * */
    function updateSecondAuth(options) {
      const deferred = $q.defer()
      const currentUser = User.getCurrentUser()

      options.bindUid = currentUser.config.email

      currentUser.simpleCall({
        query: {
          func: 'user:updateSecondAuth'
        },
        data: options
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(code)
        } else {
          deferred.reject(code)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /**
     * user:validateSecondAuth (二次验证）
     * @param  tempSid     {string}  - 用于验证的临时 session id
     * @param  verifyCode  {string}  - 验证码，没有绑定二次验证时不需要此参数
     * @param  trans       {string}  - 需要二次验证的业务名称,如 login、change_password、update_second_auth等
     *
     * @return  result     {object}
     * ResultCode:
        S_OK                         - 验证通过
        FA_INVALID_PARAMETER         - 参数错误
        FA_INVALID_STAGE             - 非合法的验证阶段，不允许进行验证
        FA_INVALID_DYNAMIC_PWD       - 动态密保/OTP 验证码错误
        FA_INVALID_VERIFY_CODE       - 短信验证码错误
        FA_INVALID_TEMP_SESSION      - 验证临时session id 过期
     * */
    function validateSecondAuth(options) {
      const deferred = $q.defer()
      const wmsvrClient = User.getCurrentUser().wmsvrClient

      wmsvrClient.simpleCall({
        query: {
          func: 'user:validateSecondAuth'
        },
        data: options
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 二次发起和查询相关的使用登录暂时构造的user, 是因为还没有登录, getCurrentUser()不能使用;
    function authSendValidCode(user, uid, pwd) {
      const deferred = $q.defer()
      user.simpleCall({
        query: {
          func: 'sms:authSendValidCode'
        },
        data: {
          uid: uid,
          password: pwd
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // http://rd.mailtech.cn/rd/coremail/wmdoc-read.php/wmsvr/user-module/user-second.md
    function querySecondAuthValidateStage(user, tempSid, trans) {
      const deferred = $q.defer()
      const currentUser = user || User.getCurrentUser()
      const data = {}
      if (tempSid) {
        data.tempSid = tempSid
      }
      if (trans) {
        data.trans = trans
      }
      currentUser.simpleCall({
        query: {
          func: 'user:querySecondAuthValidateStage'
        },
        data
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    function querySecondAuth(user, uid) {
      const deferred = $q.defer()
      user = user || User.getCurrentUser()
      user.simpleCall({
        query: {
          func: 'user:querySecondAuth'
        },
        data: {
          uid: uid
        }
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    function alertFolderUnlock(success, cancel) {
      const deferred = $q.defer() // 同时支持回调和promise的写法
      const user = User.getCurrentUser()
      // 使用timeout目的是解决弹窗偶尔加载不到文案的问题
      $timeout(function () {
        const popupInstance = $ionicPopup.prompt({
          template: $translate.instant('SAFELOCK.PASSWORD_INPUT_TIPS'),
          inputType: 'password',
          cssClass: 'box__second-auth',
          maxLength: 20,
          buttons: [{
            text: $translate.instant('OP.CANCEL'),
            type: 'button-positive',
            onTap: function (e) {
              // 取消解锁
              if (Object.prototype.toString.call(cancel) === '[object Function]') {
                cancel()
              }
              deferred.reject('取消解锁')
            }
          }, {
            text: $translate.instant('OP.OK'),
            type: 'button-default',
            onTap: function (e) {
              e.preventDefault()
              const description = this.element[0].querySelector('.popup-body > span')
              const inputValue = this.scope.data.response
              user.secondAuthenticate(inputValue)
                .then(function (result) {
                  if (result) {
                    popupInstance.close()

                    // 重置错误描述
                    description.innerText = $translate.instant('SAFELOCK.PASSWORD_INPUT_TIPS')
                    description.style.color = 'black'

                    // 更新加密文件夹的状态
                    mailFolderService.unlockAllFolders()

                    // 二次认证成功
                    if (Object.prototype.toString.call(success) === '[object Function]') {
                      success()
                    }
                    deferred.resolve('二次认证成功')
                  } else {
                    description.innerText = $translate.instant('SAFELOCK.PASSWORD_ERROR')
                    description.style.color = 'red'
                  }
                }).catch(function() {
                  deferred.reject('二次认证失败')
                })
            }
          }]
        })
      }, 500)
      return deferred.promise
    }

    return {
      triggerSecondAuth: triggerSecondAuth,
      updateSecondAuth: updateSecondAuth,
      validateSecondAuth: validateSecondAuth,
      authSendValidCode: authSendValidCode,
      querySecondAuthValidateStage: querySecondAuthValidateStage,
      querySecondAuth: querySecondAuth,
      alertFolderUnlock: alertFolderUnlock
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/services/secondAuthService.js